// extracted by mini-css-extract-plugin
export default {"select":"select--1-3si","value":"value--1-Pg3"};